import { TopNav } from '@revolut-internal/ui-kit'
import { NavLink } from 'react-router-dom'
import { FC } from 'react'

import { getRootRoute } from 'lib/router'

export const TopNavLogo: FC = () => (
  <TopNav.Logo
    use={NavLink}
    color="white"
    bg="#0FE3ED"
    useIcon="Cleaning"
    to={getRootRoute()}
  >
    NLP Portal
  </TopNav.Logo>
)
